module.exports = __webpack_public_path__ + "static/assets/58b4befec7c9e406a9f6737b72f936a1.png";